/* global */
import * as bigIcon from './coolBigIcon';

function handleSignInFrameMessage(messageEvent) {
	if (messageEvent.origin !== window.location.origin) {
		return;
	}

	const signInFrameEvent = messageEvent.data;
	switch (signInFrameEvent.event) {
		case 'FRAME_RESIZE': {
			document.querySelector('#signInFrame').style.height = `${signInFrameEvent.detail.height + 5}px`;
			break;
		}
		case 'SIGNIN_START': {
			bigIcon.swapIcon('signInTitle', 'lock');
			document.querySelector('#notMember').classList.remove('noDisplay');
			document.querySelector('#helpText').classList.add('noDisplay');
			break;
		}
		case 'SIGNIN_COMPLETE': {
			let attribute = 'data-return-url';
			if (signInFrameEvent.detail.passwordReset) {
				attribute = 'data-credentials-url';
			}
			bigIcon.setTitle('signInSuccess');
			if (signInFrameEvent.detail.type === 'mfa') {
				bigIcon.changeColor('green', 'shield');
				bigIcon.nodIcon();
				redirect(attribute);
				break;
			}
			if (bigIcon.hasClass('multiUser')) {
				bigIcon.changeColor('green', 'multiUser');
				bigIcon.nodIcon();
				redirect(attribute);
				break;
			}
			bigIcon.changeColor('green', 'unlocked', 'lock');
			redirect(attribute);
			break;
		}
		case 'SIGNIN_INVALID_CREDENTIALS':
		case 'SIGNIN_MALFORMED': {
			bigIcon.changeColor('red', 'lock');
			bigIcon.setTitle('signInFailed');
			bigIcon.shakeIcon();
			break;
		}
		case 'SIGNIN_SERVER_ERROR': {
			bigIcon.changeColor('red', 'lock');
			bigIcon.setTitle('serverError');
			bigIcon.shakeIcon();
			break;
		}
		case 'SIGNIN_NETWORK_ERROR': {
			bigIcon.changeColor('red', 'lock');
			bigIcon.setTitle('networkError');
			bigIcon.shakeIcon();
			break;
		}
		case 'SIGNIN_ACCOUNT_LOCKED': {
			if (bigIcon.hasClass('clock')) {
				bigIcon.setClockTime();
				bigIcon.changeColor('red', 'clock');
				bigIcon.shakeIcon();
				break;
			}
			// this timeout refreshes the page after the 30 minutes
			setTimeout(() => {
				location.reload();
			}, 1800000);
			bigIcon.setClockTime();
			bigIcon.swapIcon('accountLocked', 'red', 'clock');
			break;
		}
		case 'SIGNIN_MULTI_ACCOUNT': {
			bigIcon.swapIcon('selectAccount', 'multiUser');
			document.querySelector('#notMember').classList.add('noDisplay');
			break;
		}
		case 'SIGNIN_FACEBOOK_ERROR': {
			bigIcon.removeAll();
			document.querySelector('#coolBigIcon').classList.add('red');
			document.querySelector('#coolBigIcon').classList.add('lock');
			bigIcon.setTitle('facebookFailed');
			break;
		}
		case 'PASSWORD_RESET_START': {
			bigIcon.swapIcon('resetPassword', 'key');
			document.querySelector('#notMember').classList.add('noDisplay');
			document.querySelector('#helpText').classList.remove('noDisplay');
			document.querySelector('#helpText a').setAttribute('data-track-click', 'reset password : request : get help');
			bigIcon.setTitle('resetPassword');
			break;
		}
		case 'PASSWORD_RESET_EMAIL_MALFORMED': {
			bigIcon.setTitle('emailFailed');
			bigIcon.changeColor('red', 'key');
			bigIcon.shakeIcon();
			break;
		}
		case 'PASSWORD_RESET_EMAIL_SENT': {
			document.querySelector('#helpText a').setAttribute('data-track-click', 'reset password : code verify : get help');
			bigIcon.setTitle('resetPasswordCode', `<strong>${signInFrameEvent.detail.email}</strong>`);
			bigIcon.changeColor('blue', 'key');
			break;
		}
		case 'PASSWORD_RESET_CODE_VALID': {
			document
				.querySelector('#helpText a')
				.setAttribute('data-track-click', 'reset password : new password : get help');
			bigIcon.setTitle('resetPasswordNew');
			bigIcon.changeColor('blue', 'key');
			break;
		}
		case 'PASSWORD_RESET_CODE_EXPIRED': {
			bigIcon.setTitle('codeExpired');
			bigIcon.changeColor('red', 'clock');
			bigIcon.shakeIcon();
			break;
		}
		case 'PASSWORD_RESET_CODE_INVALID':
		case 'PASSWORD_RESET_CODE_MALFORMED': {
			bigIcon.setTitle('codeFailed');
			bigIcon.changeColor('red', 'key');
			bigIcon.shakeIcon();
			break;
		}
		case 'PASSWORD_RESET_TOO_MANY_REQUESTS': {
			bigIcon.changeColor('red', 'key');
			bigIcon.shakeIcon();
			bigIcon.setTitle('tooManyRequests');
			break;
		}
		case 'PASSWORD_RESET_SERVER_ERROR': {
			bigIcon.changeColor('red', 'key');
			bigIcon.shakeIcon();
			bigIcon.setTitle('serverError');
			break;
		}
		case 'PASSWORD_RESET_NETWORK_ERROR': {
			bigIcon.changeColor('red', 'key');
			bigIcon.shakeIcon();
			bigIcon.setTitle('networkError');
			break;
		}
		case 'PASSWORD_RESET_PASSWORD_SAVED': {
			document.querySelector('#helpText a').setAttribute('data-track-click', 'reset password : complete : get help');
			bigIcon.setTitle('resetSuccess');
			bigIcon.changeColor('green', 'key');
			break;
		}
		case 'PASSWORD_RESET_PASSWORD_MALFORMED': {
			bigIcon.setTitle('resetFail');
			bigIcon.changeColor('red', 'key');
			bigIcon.shakeIcon();
			break;
		}
		case 'PASSWORD_RESET_PASSWORD_MISMATCH': {
			bigIcon.setTitle('resetFail');
			bigIcon.changeColor('red', 'key');
			bigIcon.shakeIcon();
			break;
		}
		case 'MFA_START': {
			document.querySelector('#notMember').classList.add('noDisplay');
			bigIcon.swapIcon('mfa', 'shield');
			break;
		}
		case 'MFA_CODE_MALFORMED':
		case 'MFA_CODE_INVALID': {
			bigIcon.setTitle('mfaFailed');
			bigIcon.changeColor('red', 'shield');
			bigIcon.shakeIcon();
			break;
		}
		case 'MFA_CODE_EXPIRED': {
			bigIcon.setTitle('mfaExpired');
			bigIcon.changeColor('red', 'clock');
			bigIcon.shakeIcon();
			break;
		}
		case 'MFA_SERVER_ERROR': {
			bigIcon.changeColor('red', 'lock');
			bigIcon.shakeIcon();
			bigIcon.setTitle('serverError');
			break;
		}
		case 'MFA_NETWORK_ERROR': {
			bigIcon.changeColor('red', 'lock');
			bigIcon.shakeIcon();
			bigIcon.setTitle('networkError');
			break;
		}
		case 'RECOVERY_CODE_START': {
			bigIcon.swapIcon('recoveryCode', 'lock');
			break;
		}
		case 'RECOVERY_CODE_MALFORMED':
		case 'RECOVERY_CODE_INVALID': {
			bigIcon.setTitle('recoveryCodeFailed');
			bigIcon.changeColor('red', 'lock');
			bigIcon.shakeIcon();
			break;
		}
		case 'RECOVERY_CODE_SERVER_ERROR': {
			bigIcon.changeColor('red', 'lock');
			bigIcon.shakeIcon();
			bigIcon.setTitle('serverError');
			break;
		}
		case 'RECOVERY_CODE_NETWORK_ERROR': {
			bigIcon.changeColor('red', 'lock');
			bigIcon.shakeIcon();
			bigIcon.setTitle('networkError');
			break;
		}
		case 'RECOVERY_CODE_EXPIRED_CREDENTIALS': {
			bigIcon.setTitle('recoveryCodeExpiredCred');
			bigIcon.changeColor('red', 'clock');
			bigIcon.shakeIcon();
			break;
		}
		default: {
			break;
		}
	}
}

function redirect(attribute) {
	window.setTimeout(() => {
		window.location = document.getElementById('indexPage').getAttribute(attribute);
	}, 300);
}
window.addEventListener('message', handleSignInFrameMessage, false);
